'use strict';

import React from 'react';

import fill from 'lodash/fill';

class ProgressStepIndicator extends React.Component {
  render() {
    var progress = [];

    if (this.props.total && this.props.current) {
      progress = new Array(this.props.total);
      fill(progress, '');
      {
        progress = progress.map(
          function (item, i) {
            if (i + 1 === this.props.current) {
              return <div key={i} className="step step--active" />;
            } else {
              return <div key={i} className="step" />;
            }
          }.bind(this)
        );
      }
    }

    return <div className="steps">{progress}</div>;
  }
}

export default ProgressStepIndicator;
